export default {
  PageFacturae: {
    // Headers and titles
    rectificative_invoice_title: 'RECTIFIED INVOICE',
    rectifies_invoice: 'Rectifies invoice {invoiceNumber} from {invoiceDate}',
    draft_watermark: 'DRAFT',

    // QR and verification
    qr_label: 'Tax QR:',
    qr_verifiable: 'Invoice verifiable on the AEAT electronic headquarters',

    // Invoice numbers and dates
    invoice_number_label: 'Number {documentType}: ',
    external_invoice_number: 'External invoice number: ',
    invoice_date_label: 'Date {documentType}: ',
    due_date: 'Due date: ',
    operation_date: 'Operation date: ',
    start_date: 'Start date: ',
    end_date: 'End date: ',
    signing_date: 'Signing date: ',

    // Supplier section
    issuer: 'Issuer',
    business_name: 'Business name: ',
    fiscal_name: 'Fiscal name: ',
    fiscal_address: 'Fiscal address: ',
    nif_cif: 'NIF/CIF: ',
    bank_account: 'Bank account number: ',
    trade_name: 'Trade name: ',
    email_label: 'Email: ',
    phone_label: 'Phone:',
    website_label: 'Website:',

    // Customer section
    receiver: 'Receiver',
    dire_label: 'DIRe:',
    accounting_office: 'Accounting office:',
    management_body: 'Management body:',
    processing_unit: 'Processing unit:',
    proposing_body: 'Proposing body:',

    // Details section
    details: 'Details',
    details_of_budget: 'of the budget',
    details_of_delivery_note: 'of the delivery note',
    details_of_proforma: 'of the proforma',
    details_of_ticket: 'of the ticket',
    details_of_invoice: 'of the invoice',

    // Table headers
    description: 'Description',
    total: 'Total',
    quantity: 'Quantity',
    unit_price: 'Unit price',
    discount_percentage: 'Discount %',
    withholding: 'Withholding',
    total_without_tax: 'Total (without VAT/IGIC)',

    // Document type headers
    proforma_label: 'Proforma',
    budget_label: 'Budget',
    delivery_note_label: 'Delivery note',
    date_of_proforma: 'Proforma date: ',
    date_of_budget: 'Budget date: ',
    date_of_delivery_note: 'Delivery note date: ',
    file_reference: 'File',
    file_date: 'File date: ',
    client_reference: 'Client Reference',

    // Totals section
    total_without_discounts: 'Total without discounts',
    line_discount: 'Line discount',
    global_discount: 'Global discount',
    total_without_taxes: 'Total without taxes',
    total_withholding: 'Total Withholding',
    total_document: 'Total {documentType}',
    withholding_label: 'Withholding: ',
    reimbursable_label: 'Reimbursable: ',
    total_to_pay: 'Total to pay',

    // Document types for dynamic text
    invoice: 'Invoice',
    budget: 'Budget',
    delivery_note: 'Delivery note',
    proforma: 'Proforma',
    ticket: 'Ticket',

    // Footer
    page_number: 'Page {currentPage} of {totalPages}',
    document_info: 'Number {documentType}: {invoiceNumber} ({invoiceDate})',
  }
}